import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { CouponCodeInterface } from '../../../interfaces/interfaces';

export const getCouponCodesColumns = (
  setCodeToDelete: (code: CouponCodeInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setCodeToUpdate: (code: CouponCodeInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'code', headerName: 'Code', width: 130 },
  { field: 'discountType', headerName: 'Type', width: 120 },
  { field: 'discountValue', headerName: 'Value', width: 90 },
  { 
    field: 'usage', 
    headerName: 'Usage', 
    width: 100,
    valueGetter: (value, row) => `${row.usageCount || 0} / ${row.maxUsage || '∞'}`
  },
  { field: 'isGlobal', headerName: 'Global', width: 80, type: 'boolean' },
  { field: 'autoApply', headerName: 'Auto', width: 80, type: 'boolean' },
  { field: 'platformSubsidized', headerName: 'Subsidized', width: 100, type: 'boolean' },
  { 
    field: 'validFrom', 
    headerName: 'Valid From', 
    width: 110,
    valueGetter: (value, row) => row.validFrom ? new Date(row.validFrom).toLocaleDateString() : '-'
  },
  { 
    field: 'validUntil', 
    headerName: 'Valid Until', 
    width: 110,
    valueGetter: (value, row) => row.validUntil ? new Date(row.validUntil).toLocaleDateString() : '-'
  },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'description', headerName: 'Description', width: 200 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setCodeToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setCodeToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];
